module.exports = __webpack_public_path__ + "img/question-circle.493db03d.svg";